import { render, staticRenderFns } from "./FeedbackModeration.vue?vue&type=template&id=fea134f0&scoped=true"
import script from "./FeedbackModeration.vue?vue&type=script&lang=js"
export * from "./FeedbackModeration.vue?vue&type=script&lang=js"
import style0 from "./FeedbackModeration.vue?vue&type=style&index=0&id=fea134f0&prod&scoped=true&lang=css"
import style1 from "./FeedbackModeration.vue?vue&type=style&index=1&id=fea134f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea134f0",
  null
  
)

export default component.exports